<template>
    <v-data-table
        :headers="headers"
        :items="list"
        dense
        :options="options"
        @update:options="updateOptions"
        :page="page"
        disable-sort
        @update:page="updatePage"
        :footer-props="footer"
        :server-items-length="length"
        :loading="loading"
    >
        <template v-slot:[`item.code`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.item.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.code}}
        </template>

    </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import permissions from './../../data/permissions';

export default {
    name: "ItemList",
    data() {
        return {
            headers: [
                { text: "Code", value: "code" },
                { text: "Item", value: "name" },
                { text: "Description", value: "description" },
                { text: "Type", value: "type"}
            ],
            footer: {
                'items-per-page-options': [10, 25, 50]
            },
            perm: permissions
        }
    },
    computed : {
        ...mapGetters({
            list: "stock/item/list/data",
            options: "stock/item/list/options",
            loading: "stock/item/list/loading",
            length: "stock/item/list/length",
            hasPermission: "authentication/hasPermission",
            page: "stock/item/list/page"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "stock/item/list/updateOptions",
            updatePage: "stock/item/list/updatePage",
        }),
        handleClickRow(item){
            this.$router.push({ name: 'ItemDisplay', params: { id: item.id}})
        }
    }
}
</script>

<style>
</style>